import React, { useEffect, useRef } from 'react'
import DfbSymbol from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_symbol'
import DfbHeadline from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_headline'
import DfbParagraph from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_paragraph'

const MSuccessState = ({ data }) => {
  const { headline, description, backlink, backlinks } = data
  const rootRef = useRef()

  useEffect(() => {
    rootRef.current?.scrollIntoView({ behavior: 'smooth' })
  }, [])

  return (
    <center style={{ margin: '0 auto', padding: '120px 0' }} ref={rootRef}>
      <div style={{ height: '64px', width: '64px', marginBottom: '24px' }}>
        <DfbSymbol icon_type="check-circle" />
      </div>

      {headline && <DfbHeadline headline={headline} headline_level="h4" />}
      {description && <DfbParagraph text={description} />}
      {backlink && (
        <a href={backlink?.link} className="dfb-Anchor">
          <span className="dfb-Anchor-label">{backlink?.text}</span>
        </a>
      )}
      {backlinks &&
        backlinks.map((backlink) => (
          <div>
            <a href={backlink?.link} className="dfb-Anchor">
              <span className="dfb-Anchor-label">{backlink?.text}</span>
            </a>
          </div>
        ))}
    </center>
  )
}
export default MSuccessState
